import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperationBuilder } from '../../models/builders/operation.builder';
import { Operation } from '../../models/operation';
import { OperationModeBuilder } from '../../models/builders/operation-mode.builder';

const operationBody = (operation: Operation) => ({
  name: operation.name,
  hash: operation.hash,
  index: operation.index,
  mode: operation.mode,
  active: operation.active
});

@Injectable()
export class OperationApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }operations`;
  }

  createOperation(operation) {
    return this.httpClient.post(this.apiUrl, operationBody(operation)).pipe(map(OperationBuilder.fromJson));
  }

  deleteOperation(operation: Operation) {
    return this.httpClient.delete(`${ this.apiUrl }/${ operation.hash }`);
  }

  getOperations() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(OperationBuilder.fromList));
  }

  getOperationModes() {
    return this.httpClient.get(`${ this.apiUrl }/modes`)
    .pipe(map(OperationModeBuilder.fromList));
  }

  getOperation(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(OperationBuilder.fromJson));
  }

  updateOperation(operation: Operation) {
    return this.httpClient.put(`${ this.apiUrl }/${ operation.hash }`, operationBody(operation));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operation-api.service.ts